<template>
  <div class="monitor-tree">
    <!-- sin niveles: listado plano -->
    <slot v-if="!nodes.length" name="leaf" :items="items" />

    <MonitorTreeNode v-else v-for="node in nodes" :key="node.path"
                     :node="node" :expanded="expandedMap" :summarize="summarize"
                     @toggle="toggle">
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
    </MonitorTreeNode>
  </div>
</template>

<script>
  import MonitorTreeNode from './monitorTreeNode'
  import { treePaths } from './monitorTreeBuilder'
  import Storage from '@/handler/storageLocal'

  // árbol de agrupamiento multinivel. Los nodos los arma la vista (buildTree)
  // para poder usar el mismo orden al navegar el panel lateral.
  export default {
    components: {
      MonitorTreeNode,
    },
    props: {
      nodes: { type: Array, required: true },
      items: { type: Array, default: () => [] },
      expandAll: { type: Boolean, default: false },
      // muestra todo desplegado sin tocar las ramas guardadas (ej: al llegar
      // desde una notificación)
      forceExpand: { type: Boolean, default: false },
      summarize: { type: Function, default: null },
      // si se indica, las ramas abiertas se recuerdan entre visitas
      storageKey: { type: String, default: '' },
      // id de un registro a mostrar: se abren las ramas que lo contienen
      revealId: { type: [Number, String], default: null },
    },
    data: () => {
      return {
        expanded: {},
      }
    },
    created() {
      if(!this.storageKey) return
      try {
        var saved = JSON.parse(Storage.getValue(this.storageKey) || '{}')
        if(saved && typeof saved == 'object') this.expanded = saved
      } catch (error) {
        this.expanded = {}
      }
    },
    computed: {
      expandedMap() {
        if(!this.expandAll && !this.forceExpand) return this.expanded
        var map = {}
        treePaths(this.nodes).forEach(path => { map[path] = true })
        return map
      },
    },
    watch: {
      revealId: {
        immediate: true,
        handler() {
          this.reveal()
        },
      },
      nodes() {
        this.reveal()
      },
      expandAll(value) {
        if(!value) this.expanded = {}
      },
      expanded: {
        deep: true,
        handler(value) {
          if(!this.storageKey) return
          // solo las ramas abiertas
          var open = {}
          Object.keys(value).forEach(path => { if(value[path]) open[path] = true })
          Storage.setValue(this.storageKey, JSON.stringify(open))
        },
      },
    },
    methods: {
      reveal() {
        if(this.revealId === null || this.revealId === undefined || this.revealId === '') return
        var id = String(this.revealId)
        var open = nodes => {
          nodes.forEach(node => {
            if(node.items.some(item => String(item.id) == id)) {
              this.$set(this.expanded, node.path, true)
              open(node.children)
            }
          })
        }
        open(this.nodes)
      },
      toggle(path) {
        if(this.forceExpand) return
        if(this.expandAll) {
          // al contraer uno desde "todo desplegado" se pasa a modo manual
          var map = Object.assign({}, this.expandedMap)
          delete map[path]
          this.expanded = map
          this.$emit('manual')
          return
        }
        this.$set(this.expanded, path, !this.expanded[path])
      },
    },
  }
</script>

<style scoped>
  .monitor-tree {
    border: 1px solid var(--app-color-border);
    border-radius: 10px;
    overflow: hidden;
  }
</style>
